<template>
  <div class="module-container">
    <div class="container">
      <div class="module-title">为什么多数传统企业举步维艰？</div>
      <div class="module-subtitle">我们深入行业一线，识别出阻碍企业增长的四大"隐形枷锁"</div>
      <div class="shackles-cards">
        <div class="shackle-card" v-for="(item, index) in shacklesItems" :key="index">
          <img class="card-icon" :src="require(`@/assets/img/home/InvisibleShackles/${item.iconId}.png`)">
          <div class="card-title">{{ item.title }}</div>
          <ul class="card-description">
            <li v-for="(desc, descIndex) in item.description" :key="descIndex">{{ desc }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      shacklesItems: [
        {
          title: '用人成本高',
          iconId: 'icon_yrcbg',
          description: [
            '核心人才留不住，因薪酬压力难以维系；一般工人不能闲置，否则成本过高。',
            '项目到来时人手不足，项目空闲时团队却照常发工资。',
            '人力从“资产”变为“负债”，盈利能力持续下降。'
          ]
        },
        {
          title: '供应商资源弱',
          iconId: 'icon_gyszyr',
          description: [
            '因采购量小，在供应商体系中处于“散户”地位，无议价权。',
            '采购成本高于同行，且面临必须现结的资金压力，无法享受账期。',
            '市场行情下行但成本却在上涨，核心是身份与体量不足。'
          ]
        },
        {
          title: '核心竞争力减少',
          iconId: 'icon_hxjzljs',
          description: [
            '无自有拳头产品与专精技术，业务范围广而不精。',
            '长期在低端市场卷价格，缺乏议价能力。',
            '遇到稍有技术含量的项目，因实力不足只能放弃。'
          ]
        },
        {
          title: '无品牌资质，难接优质项目',
          iconId: 'icon_wppzz',
          description: [
            '想接大项目，但甲方只看资质与业绩，缺乏对应“身份证”。',
            '只能挂靠他人名下接单，为人作嫁衣，风险自担。',
            '始终依附于大树，无法成长为独立的核心主体。'
          ]
        }
      ]
    }
  },
};
</script>

<style lang="less" scoped>
.module-container {
  background-color: #1F1F28;
  padding: 64px 0;

  .container {
    max-width: @content-width;
    margin: 0 auto;
  }

  .module-title {
    font-size: 32px;
    font-weight: 600;
    color: #fff;
    text-align: center;
    margin-bottom: 16px;
  }

  .module-subtitle {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.6);
    text-align: center;
    margin-bottom: 64px;
  }

  .shackles-cards {
    display: flex;
    gap: 32px;
    justify-content: center;
    flex-wrap: wrap;

    .shackle-card {
      width: calc(25% - 24px);
      background: rgb(56, 56, 66);
      border-radius: 12px;
      padding: 40px 32px;
      transition: all 0.3s ease;

      &:hover {
        background-color: #F97316;
        transform: translateY(-8px);
        box-shadow: 0 8px 32px rgba(255, 107, 0, 0.3);
      }

      .card-icon {
        width: 40px;
        height: 40px;
        margin-bottom: 16px;
      }

      .card-title {
        font-size: 18px;
        font-weight: 600;
        color: #fff;
        margin-bottom: 16px;
      }

      .card-description {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.7);
          line-height: 1.6;
          margin-bottom: 8px;
          position: relative;
          padding-left: 16px;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 8px;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: rgba(255, 255, 255, 0.5);
          }

          &:last-child {
            margin-bottom: 0;
          }
        }

        .shackle-card:hover & li::before {
          background-color: rgba(255, 255, 255, 0.8);
        }
      }

      &:hover {
        .card-title,
        .card-description li {
          color: #fff;
        }
      }
    }
  }
}
</style>

